import StorageService from './storage-service';
import { v4 as uuid } from 'uuid';

const SESSION_ID = 'core/sessionId';

export default function sessionId() {
  let id = StorageService.getItem(SESSION_ID);

  if (id == null) {
    id = uuid();
    StorageService.setItem(SESSION_ID, id);
  }

  return id;
}
